import { render, staticRenderFns } from "./PsiDetailConnectAccounts.vue?vue&type=template&id=764c663f&scoped=true"
import script from "./PsiDetailConnectAccounts.vue?vue&type=script&lang=js"
export * from "./PsiDetailConnectAccounts.vue?vue&type=script&lang=js"
import style0 from "./PsiDetailConnectAccounts.vue?vue&type=style&index=0&id=764c663f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c663f",
  null
  
)

export default component.exports